function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Info = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "InfoIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "M12 2c5.523 0 10 4.093 10 9.142 0 5.05-4.477 9.142-10 9.142a10.71 10.71 0 0 1-4.685-1.063l-3.01 2.58a.816.816 0 0 1-1.183-.123.908.908 0 0 1-.18-.7l.747-4.75C2.622 14.774 2 13.024 2 11.142 2 6.093 6.477 2 12 2zm1.12 8h-2.25v6.5h2.25V10zM12 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
    })
  }));
});
Info.displayName = 'InfoIcon';
export default Info;